"use client";

import React from "react";
import { message, Modal } from "antd";
import { academyEquipmentsService } from "../../../../shared/services";

const { confirm } = Modal;

export default function useDeleteEquipment() {
  const [loading, setLoading] = React.useState(false);

  const showDeleteConfirm = (valId: number, val: string) => {
    if (!valId) {
      message.error("ID del equipo no válido");
      return;
    }

    confirm({
      title: `¿Estás seguro de borrar el equipo con el id: ${valId}?`,
      content: `Una vez ejecutada esta acción no hay vuelta atrás, estás por borrar a "${val}". Si deseas continuar, dale click a "Borrar equipo". En caso contrario, solo oprime "Cancelar".`,
      okText: "Borrar equipo",
      okType: "danger",
      cancelText: "Cancelar",
      async onOk() {
        try {
          setLoading(true);
          await academyEquipmentsService.remove(valId);
          message.success(`Se ha borrado con éxito el equipo con id: ${valId}`);
        } catch (err: any) {
          message.error(`Error: ${err.message}`);
        } finally {
          setLoading(false);
        }
      },
    });
  };

  return { showDeleteConfirm, loading };
}
